import { render } from "./currency-convert.vue?vue&type=template&id=4cd2f812"
import script from "./currency-convert.vue?vue&type=script&lang=js"
export * from "./currency-convert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__